<template>
<div class="md-3">
  <ul>
    <li>
      <router-link to="/member/edit/profile" :class="isActive('profile')">プロフィールを編集</router-link>
    </li>
    <li>
      <router-link to="/member/edit/tel" :class="isActive('tel')">電話番号を変更</router-link>
    </li>
    <li>
      <router-link to="/member/edit/email" :class="isActive('email')">メールアドレスを変更</router-link>
    </li>
    <li>
      <router-link to="/member/edit/password" :class="isActive('password')">パスワード変更</router-link>
    </li>
    <li>
      <a href="javascript:void(0)" @click="logout">ログアウト</a>
    </li>
  </ul>
</div>
</template>

<style scoped>
ul {
  list-style-type: none;
  width: 300px;
}
ul > li {
  padding: 10px 0;
}
ul > li > a {
  color: #4f4f4f;
}
ul > li > a.active {
  color: #29b28d;
}

@media screen and (max-width: 768px){
  .md-3 {
    display: none;
  }
}
</style>

<script>
import { useRouter, useRoute } from "vue-router";
import http from "axios";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();

    const logout = async () => {
      if (confirm("ログアウトします。よろしいですか？")) {
        await http.post('/api/marketer/logout');
        router.push('/member/login');
      }
    };

    const isActive = (path) => {
      if (route.path.indexOf(path) > -1) {
        return 'active';
      }
    }

    return { logout, isActive };
  },
}
</script>